module.exports = __webpack_public_path__ + "public/SiteIcons/lightModeIcon.svg?4d0c0f3a";